export default __webpack_public_path__ + "static/media/EMSD.def6f915.jpg";